import { initializeChakraComponent } from 'Shared/chakra-initialize';
import { AnswersData } from 'Guide/SurveyPrompts/SurveyPopUpData';
import { useEffect, useState } from 'react';
import {
   markAnswersSurveySeen,
   getCountOfTimesSeenSurvey,
   getQuestionIdsForSeenSurveys,
   alreadyClickedToTakeSurvey,
} from 'Guide/SurveyPrompts/RecentSurveys';
import { safeLocalStorage } from '@ifixit/utils';
import { useMemo } from 'react';
import { SurveyPopUp } from 'Guide/SurveyPrompts/SurveyPopUp';

const showWithAllConditionsFlag = window.location.hash === '#show-survey-all-conditions';
const showWithFewerConditionsFlag = window.location.hash === '#show-survey-fewer-conditions';
const chance = Math.random();

function couldShowSurveyToast() {
   // TODO: remove flag and false option
   // We want to add some element of chance to seeing the survey.
   // While developing, this can be difficult.
   const shouldNotShow = showWithFewerConditionsFlag ? false : chance >= 0.2;
   if (
      (!showWithAllConditionsFlag && !showWithFewerConditionsFlag) ||
      !safeLocalStorage.isAvailable ||
      shouldNotShow
   ) {
      return false;
   }

   const seenSurveyCount = getCountOfTimesSeenSurvey(AnswersData.id);
   let haveNotAskedToTakeRecently = seenSurveyCount < 1;
   if (App.reputation < 5000) {
      const questionIds = getQuestionIdsForSeenSurveys();
      haveNotAskedToTakeRecently = !questionIds.includes(App.questionid) && seenSurveyCount < 2;
   }

   return !alreadyClickedToTakeSurvey(AnswersData.id) && haveNotAskedToTakeRecently;
}
export function QuestionViewSurveyPopUp() {
   const [hasScrolledEnough, setHasScrolledEnough] = useState(false);
   const [timeElapsed, setTimeElapsed] = useState(false);
   const [metAllConditions, setMetAllConditions] = useState(false);

   useEffect(() => {
      // Ensure user scrolled 30% of page at least
      const handleScroll = () => {
         const scrollPosition = window.scrollY + window.innerHeight;
         const pageHeight = document.documentElement.scrollHeight;
         if (scrollPosition >= pageHeight * 0.3) {
            setHasScrolledEnough(true);
         }
      };

      window.addEventListener('scroll', handleScroll);

      // Ensure user has been on page for 15 seconds
      const timer = setTimeout(
         () => {
            setTimeElapsed(true);
         },
         showWithFewerConditionsFlag ? 0 : 15 * 1000
      );

      return () => {
         window.removeEventListener('scroll', handleScroll);
         clearTimeout(timer);
      };
   }, []);

   // Show toast once triggers are all hit
   // eslint-disable-next-line react-hooks/use-memo
   const couldShowToast = useMemo(couldShowSurveyToast, []);
   useEffect(() => {
      if (couldShowToast && hasScrolledEnough && timeElapsed) {
         // eslint-disable-next-line react-hooks/set-state-in-effect -- TODO: grandfathered in react-hooks 7.1 / ESLint 10 upgrade
         setMetAllConditions(true);
      }
   }, [hasScrolledEnough, timeElapsed]);

   const markSurveySeen = () => {
      markAnswersSurveySeen(App.questionid);
   };

   return (
      <>{metAllConditions && <SurveyPopUp {...AnswersData} markSurveySeen={markSurveySeen} />}</>
   );
}

initializeChakraComponent('QuestionViewSurveyPopUpComponent', QuestionViewSurveyPopUp);
